/**
 * Common methods to make AJAX calls
 */
 import axios from 'axios';

 function getCommonHeader() {
     return {
         mode: 'no-cors',
         withCredentials: true,
         credentials: 'same-origin',
         crossdomain: true,
         headers: {
             'Content-Type': 'application/json',
             'Access-Control-Allow-Credentials': 'true',
             Accept: 'application/json',
             'Access-Control-Allow-Origin': '*',
             'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
             'Access-Control-Allow-Headers': 'X-Requested-With, content-type, Authorization'
         },
     };
 }
 
 export default {
     /**
       * Makes a POST request to the API,
       */
     post: async (url, data) => {
         let responseData;
         try {
             const response = await axios.post(url, { ...data }, getCommonHeader());
 
             responseData = response.data;
         } catch (error) {
             console.log(error);
         }
 
         return responseData;
     },
 };
 